module.exports = __webpack_public_path__ + "img/block-2.910a0b1c.jpg";